exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".more-categories[_v-0a3f94f4]{border-top:1px solid #ddd}.more-categories ul[_v-0a3f94f4]{font-size:0;list-style:none;margin:0 0 24px;padding:0}.more-categories ul li[_v-0a3f94f4]{display:inline;font-size:12px;line-height:24px;cursor:pointer;margin-left:12px}.more-categories ul li[_v-0a3f94f4]:before{content:\"\";display:inline-block;margin-right:3px;background-image:url(" + require("../assets/tag.svg") + ");background-size:cover;height:12px;width:12px}.more-categories ul li a[_v-0a3f94f4]{color:grey;cursor:pointer}.more-categories ul li a[_v-0a3f94f4]:hover{opacity:.6}.more-categories.wide-view ul li[_v-0a3f94f4]{width:33.3%}.dark-theme .more-categories ul li a[_v-0a3f94f4]{color:#d3d3d3}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-0a3f94f4&scoped=true!./~/less-loader!./~/vue-loader/lib/selector.js?type=style&index=0!./~/eslint-loader!./src/components/categories.vue
// module id = 273
// module chunks = 0